import {
  GET_PROMOCIONES_SUCURSAL_START,
  GET_PROMOCIONES_SUCURSAL_SUCCESS,
  GET_PROMOCIONES_SUCURSAL_ERROR
} from '../actions'

const initialState = {
  loading: false,
  payload: [],
  error: null
}

const promociones = (state = initialState, { type, payload, error }) => {

  switch(type) {

    case GET_PROMOCIONES_SUCURSAL_START:
      return {
        ...state,
        loading: true,
        error: null
      }

    case GET_PROMOCIONES_SUCURSAL_SUCCESS:
      return {
        ...state,
        loading: false,
        payload
      }

    case GET_PROMOCIONES_SUCURSAL_ERROR:
      return {
        ...state,
        loading: false,
        error
      }

    default: return state

  }

}

export default promociones